(function () {
  function hideNode(node) {
    if (!node || node.classList.contains('purchase-notes') || node.classList.contains('order-steps')) return;
    node.hidden = true;
    node.setAttribute('aria-hidden', 'true');
    node.classList.add('cod-hidden-payment');
    node.style.setProperty('display', 'none', 'important');
    node.style.setProperty('visibility', 'hidden', 'important');
    node.style.setProperty('height', '0', 'important');
    node.style.setProperty('min-height', '0', 'important');
    node.style.setProperty('max-height', '0', 'important');
    node.style.setProperty('margin', '0', 'important');
    node.style.setProperty('padding', '0', 'important');
    node.style.setProperty('border', '0', 'important');
    node.style.setProperty('overflow', 'hidden', 'important');
  }

  function hidePaymentButtons() {
    document.querySelectorAll('.product-form').forEach(function (form) {
      form.querySelectorAll([
        '.shopify-payment-button',
        '[data-shopify="payment-button"]',
        '.additional-checkout-buttons',
        '.dynamic-checkout__content',
        '.shopify-payment-button__button',
        '.shopify-payment-button__more-options',
        'shopify-accelerated-checkout',
        'shopify-accelerated-checkout-cart',
        'shopify-paypal-button',
        'paypal-buttons',
        'iframe[src*="paypal"]',
        'iframe[src*="PayPal"]',
        '[id*="paypal"]',
        '[id*="PayPal"]',
        '[class*="paypal"]',
        '[class*="PayPal"]'
      ].join(',')).forEach(function (element) {
        hideNode(element.closest('.shopify-payment-button, [data-shopify="payment-button"], .additional-checkout-buttons, .dynamic-checkout__content') || element);
      });

      form.querySelectorAll('a').forEach(function (link) {
        var text = (link.textContent || '').trim().toLowerCase();
        var href = link.getAttribute('href') || '';
        if (text.indexOf('more payment') !== -1 || href === '#' || href.slice(-1) === '#') {
          hideNode(link);
        }
      });
    });
  }

  hidePaymentButtons();
  [100, 300, 700, 1500, 3000, 5000].forEach(function (delay) {
    setTimeout(hidePaymentButtons, delay);
  });

  if (window.MutationObserver) {
    new MutationObserver(hidePaymentButtons).observe(document.body, { childList: true, subtree: true });
  }
})();
